import { IoIosHome } from "react-icons/io";
import { FaUsers } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";

export const REACT_APP_KEY_NAME = "sporting-cryptic";

export const LOADER_OVERRIDE = {
  display: "block",
  margin: "0 auto",
};

export const ROLES = {
  SUPER_ADMIN: 0,
  ADMIN: 1,
  USER: 2,
};

export const QUIZ_ACTIVE = {
  ACTIVE: true,
  DEACTIVE: false,
};

export const ROLES_MAP = {
  0: "Super Admin",
  1: "Admin",
  2: "User",
};

export const adminDashboardLinks = [
  {
    icon: IoIosHome,
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    icon: FaSearch,
    title: "Quiz",
    to: "/admin/dashboard/quizes",
  },
];

export const dashboardLinks = [
  // {
  //   icon: BsFillGrid1X2Fill,
  //   title: "Funding Dashboard",
  //   to: "/dashboard",
  // }
];
